function getHeaderCellClass ({
  column,
  rowIndex,
  columnIndex,
  store
}) {
  const classes = [column.className].filter(Boolean)
  const headerCellClassName = store.table.headerCellClassName
  if (typeof headerCellClassName === 'string') {
    classes.push(headerCellClassName)
  } else if (typeof headerCellClassName === 'function') {
    classes.push(headerCellClassName({
      rowIndex,
      columnIndex,
      column
    }))
  }
  return classes.join(' ')
}

function getHeaderCellStyle({
  rowIndex,
  columnIndex,
  column,
  store
}) {
  let headerCellStyle = store.table.headerCellStyle
  if (typeof headerCellStyle === 'function') {
    headerCellStyle = headerCellStyle({
      rowIndex,
      columnIndex,
      column
    })
  }
  const { headerHeight: height } = column
  const _height = height - 1
  const style = {
    ...headerCellStyle,
    height: _height + 'px', // 防止超过或等于后错位,动态行高的时候去掉
  }
  if (parseInt(column.width)) {
    style.width = parseInt(column.width) + 'px' // 解决windows环境不会自动继承td的宽度，导致会出现width有小数点问题
  }
  return style
}

function eventsFactory (h, {
  column,
  rowIndex,
  columnIndex,
  label,
  store,
  handleEvent
}, context) {
  let times
  const cellMouseenter = (event) => {
    handleEvent && handleEvent(event, { column, eventType: 'mouse-enter', rowIndex, columnIndex, event })
  }
  const cellMouseleave = (event) => {
    handleEvent && handleEvent(event, { column, eventType: 'mouse-leave', rowIndex, columnIndex, event })
  }

  const handleHeaderClick = (event) => {
    if (!column) {
      return
    }
    if (!store.isReadyDraging(column)) {
      if (column.sortable) {
        store.sortChange(column)
      }
    }
    if (times) return null
    times = setTimeout(() => {
      times = null
      handleEvent && handleEvent(event, { column, rowIndex, columnIndex, eventType: 'click' })
    }, 200)
  }

  const handleHeaderDblclick = (event) => {
    if (!column) {
      return
    }
    times && clearTimeout(times)
    times = null
    handleEvent && handleEvent(event, { column, eventType: 'dblclick', rowIndex, columnIndex })
  }

  const handleHeaderContextmenu = (event) => {
    if (!column) {
      return
    }
    handleEvent && handleEvent(event, { column, eventType: 'contextmenu', rowIndex, columnIndex })
  }

  return {
    mouseenter: cellMouseenter,
    mouseleave: cellMouseleave,
    click: handleHeaderClick,
    dblclick: handleHeaderDblclick,
    contextmenu: handleHeaderContextmenu,
  }
}
export function createHeaderCellContentWrap () {
  return {
    functional: true,
    render (h, context) {
      const slots = context.slots().default || []

      const on = eventsFactory(h, context.props, context)
      const { column, headerAlign } = context.props

      const cellClass = getHeaderCellClass(context.props)
      const style = getHeaderCellStyle(context.props)
      const {
        labelClassName,
        headerCellRender,
      } = column
      const className = ['virtual-header-cell', labelClassName, cellClass]
      const align = column.align || column.textAlign || headerAlign || 'left'
      const alignClassName = align ? 'virtual-header-cell-' + align : ''
      className.push(alignClassName)
      if (headerCellRender) {
        className.push('virtual-header-cell__custom-render')
      }
      return h('div', {
        class: className.filter(Boolean),
        style,
        on
      }, slots)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/header-thead/cell-content-wrap.js